import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import DoorClosed from './icon-door-closed.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <DoorClosed {...validProps} />;
}
SvgComponent.iconName = 'door-closed';

/**
 * @deprecated This is a legacy icon
 */
export const DoorClosedIcon = svgIconWrapper(SvgComponent);
